import { useToast } from '../hooks/useToast'

export const TOAST_MESSAGES = {
    SAVE_SUCCESS: 'Changes saved successfully',
    SAVE_ERROR: 'Failed to save changes',
    DELETE_SUCCESS: 'Item deleted successfully',
    DELETE_ERROR: 'Failed to delete item',
    UPDATE_SUCCESS: 'Update successful',
    UPDATE_ERROR: 'Update failed',
    GENERIC_ERROR: 'Something went wrong. Please try again.',
    NETWORK_ERROR: 'Network error. Please check your connection.',
    UNAUTHORIZED: 'You are not authorized to perform this action',
    SESSION_EXPIRED: 'Your session has expired. Please log in again.',
} as const

export function useToastMessages() {
    const toast = useToast()

    const showSaveSuccess = (customMessage?: string) => {
        toast.success(customMessage || TOAST_MESSAGES.SAVE_SUCCESS)
    }

    const showSaveError = (error?: Error | string) => {
        const message = typeof error === 'string'
            ? error
            : error?.message || TOAST_MESSAGES.SAVE_ERROR
        toast.error(message)
    }

    const showDeleteSuccess = (customMessage?: string) => {
        toast.success(customMessage || TOAST_MESSAGES.DELETE_SUCCESS)
    }

    const showDeleteError = (error?: Error | string) => {
        const message = typeof error === 'string'
            ? error
            : error?.message || TOAST_MESSAGES.DELETE_ERROR
        toast.error(message)
    }

    const showUpdateSuccess = (customMessage?: string) => {
        toast.success(customMessage || TOAST_MESSAGES.UPDATE_SUCCESS)
    }

    const showUpdateError = (error?: Error | string) => {
        const message = typeof error === 'string'
            ? error
            : error?.message || TOAST_MESSAGES.UPDATE_ERROR
        toast.error(message)
    }

    const showNetworkError = () => {
        toast.error(TOAST_MESSAGES.NETWORK_ERROR)
    }

    const showUnauthorized = () => {
        toast.error(TOAST_MESSAGES.UNAUTHORIZED)
    }

    const showSessionExpired = () => {
        toast.error(TOAST_MESSAGES.SESSION_EXPIRED)
    }

    return {
        showSaveSuccess,
        showSaveError,
        showDeleteSuccess,
        showDeleteError,
        showUpdateSuccess,
        showUpdateError,
        showNetworkError,
        showUnauthorized,
        showSessionExpired,
    }
}

export function handleHttpError(error: any) {
    const toast = useToast()

    // Handle API error responses that include a message
    if (error?.message) {
        toast.error(error.message)
        return
    }

    // Handle 500 errors
    if (error?.status === 500 || error?.statusCode === 500) {
        toast.error(TOAST_MESSAGES.GENERIC_ERROR)
        return
    }

    // Handle other error types if needed
    toast.error(TOAST_MESSAGES.GENERIC_ERROR)
} 